import { useCallback, useEffect, useState } from "react";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
// redux
import { connect } from "react-redux";
// router
import { useLocation } from "react-router-dom";
// dominio
import { urlDomain } from "../../../utils/services/config/index";
import ModalLinksEmbeded from "./ModalLinkEmbeded";

function DashboardLogistics(props) {
  const location = useLocation();
  // altura fixa do iframe (evita loop de resize com o mapa)
  const iframeHeight = "100vh";
  // id do iframe
  const iframeId = "iframeEmbedado";
  // dominio do site do iframe
  const targetOrigin = `https://dashboard.${urlDomain}`;
  // const targetOrigin = `http://localhost:5173`;

  const [modalLink, setModalLink] = useState(false);

  const sendMessage = useCallback((data) => {
    const iframe = document.getElementById(iframeId);

    if (!iframe) return;

    const send = () => {
      iframe.contentWindow.postMessage(
        {
          type: "IFRAME_MESSAGE",
          payload: data,
        },
        targetOrigin,
      );
    };

    if (iframe.contentWindow) {
      send();
    } else {
      iframe.addEventListener("load", send, { once: true });
    }
  }, []);

  const sendDataIframe = () => {
    const reduxData = props.state.global_user_data.data;

    sendMessage({
      id: reduxData.foundLogin.id,
      email: reduxData.foundLogin.email,
      name: reduxData.foundLogin.nome,
      photo: reduxData.foundLogin.foto,
      token: reduxData.token,
      refreshToken: reduxData.refreshToken,
      eventId: location.state.idEvent,
    });
  };

  useEffect(() => {
    // recebe sinal de "ready" para reenviar os dados quando o iframe estiver pronto
    const handler = (event) => {
      if (event.data?.type === "ready") {
        sendDataIframe();
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    // envia os dados assim que o iframe terminar de carregar (evita corrida de timing)
    const iframe = document.getElementById(iframeId);
    if (!iframe) return;

    const onLoad = () => sendDataIframe();
    iframe.addEventListener("load", onLoad);
    return () => iframe.removeEventListener("load", onLoad);
  }, []);

  return (
    <>
      {modalLink && (
        <ModalLinksEmbeded
          isOpen={modalLink}
          toggle={() => setModalLink(false)}
          eventId={location.state.idEvent}
          targetOrigin={targetOrigin}
        />
      )}
      <Card>
        <CardBody>
          {/* <CardTitle>Dashboard Transfer</CardTitle> */}
          <CardTitle>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="success"
                className="btn-rounded waves-effect waves-light events-button-add"
                onClick={() => {
                  setModalLink(true);
                }}
              >
                Link Externo
              </Button>
            </div>
          </CardTitle>
          <iframe
            src={`${targetOrigin}/plus`}
            style={{
              width: "100%",
              border: "0",
              overflow: "hidden",
              height: iframeHeight,
            }}
            scrolling="no"
            id={iframeId}
          />
        </CardBody>
      </Card>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(DashboardLogistics);
